import styled from "styled-components"
import {useState} from "react"
import ModalDownloadApp from "./ModalDownloadApp"

const MobileAppHeader = () => {
	const [selectedStore, setSelectedStore] = useState(null)
	return (
		<Wrapper>
			<Title>
				<h1>Мобильное приложение</h1>
				<p className="description">
					Самый настоящий помощник водителя: путевой лист, оптимизация маршрутов, электронные накладные, архив
					поездок, график работы и многое другое.
				</p>
				<StoreButtonsWrapper>
					<StoreButton onClick={() => setSelectedStore('google-play')} store="google-play"/>
					<StoreButton onClick={() => setSelectedStore('app-store')} store="app-store"/>
					<StoreButton onClick={() => setSelectedStore('app-gallery')} store="app-gallery"/>
				</StoreButtonsWrapper>
			</Title>
			<Image>
				<img src={"/assets/img/jpg/mobile-app/iphone.jpg"} loading="lazy"/>
			</Image>
			<ModalDownloadApp selectedStore={selectedStore} setSelectedStore={setSelectedStore}/>
		</Wrapper>
	)
}

export default MobileAppHeader

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`
const Title = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const Image = styled.div`
    display: flex;
    justify-content: flex-end;
    @media (max-width: 992px) {
        justify-content: center;
    }

    img {
        width: 100%;
        display: block;
        max-width: 19.44rem;
        @media (max-width: 992px) {
            max-width: 16.66rem;
        }
    }
`
const StoreButtonsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 1.11rem 0;
`
const StoreButton = styled.div`
    background-image: url(${props => "/assets/img/png/mobile-app/" + props.store + ".png"});
    background-size: 100% auto;
    transition: opacity .3s;
    cursor: pointer;
    aspect-ratio: 169 / 50;
    width: 8rem;

    :hover {
        opacity: .7;
    }
`